"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWarningMessage = exports.getRuleMessage = void 0;
var fnumber_1 = require("../methods/fnumber");
var fmoney_1 = require("../methods/fmoney");
var msgRegex = {
    minimum: /\{\{minimum\}\}/g,
    maximum: /\{\{maximum\}\}/g,
    exclusiveMaximum: /\{\{exclusiveMaximum\}\}/g,
    exclusiveMinimum: /\{\{exclusiveMinimum\}\}/g,
    multipleOf: /\{\{multipleOf\}\}/g,
    maxLength: /\{\{maxLength\}\}/g,
    minLength: /\{\{minLength\}\}/g,
    maxItems: /\{\{maxItems\}\}/g,
    minItems: /\{\{minItems\}\}/g,
    pattern: /\{\{pattern\}\}/g,
    format: /\{\{format\}\}/g,
    enum: /\{\{enum\}\}/g,
    title: /\{\{title\}\}/g,
    value: /\{\{value\}\}/g
};
var mustacheRegex = /{{([a-z.\[\]\s\?\"\'\:\(\)\+]*)}}/gim;
/**
 * pobranie komunikatu błedu
 *
 * @export
 * @param {IInternal} internal dane wewnętrzne obiektu
 * @param {string} rule typ błedu
 * @param {*} value wartośc pola
 * @param {*} [$schema=null] schemat z wyliczonymi wartościami
 * @returns {string} komunikat błedu
 */
function getRuleMessage(internal, rule, value, $schema) {
    if ($schema === void 0) { $schema = null; }
    $schema = $schema || internal.schema;
    var msg = internal.schema.validationMessages ? internal.schema.validationMessages[rule] : undefined;
    if (msg === undefined) {
        if (rule === 'format' && internal.schema.format) {
            msg = internal.options.validationMessages['format.' + internal.schema.format];
            if (msg === undefined) {
                msg = internal.options.validationMessages[internal.schema.format];
            }
        }
        else if (rule === 'type' && internal.schema.type) {
            msg = internal.options.validationMessages['type.' + internal.schema.type];
            if (msg === undefined) {
                msg = internal.options.validationMessages[internal.schema.type];
            }
        }
        if (msg === undefined) {
            msg = internal.options.validationMessages[rule] || rule;
        }
        // jeśli na starcie było zdefiniowane jako numer to od razu podmień
        if (typeof internal.schema[rule] === 'number') {
            msg = msg.replace(msgRegex[rule] || 'rrr', function () {
                return internal.schema[rule] === undefined ? '' : fnumber_1.default(internal.schema[rule]);
            });
        }
    }
    // zamiana {{maxLength}} na prawdziwą wartość
    return msg.replace(mustacheRegex, function (match, matchrule) {
        switch (matchrule) {
            case 'key':
                return internal.schema.$key || '';
            case 'title':
                return $schema.title || internal.schema.$key || '';
            case 'format':
                return internal.schema.format || '';
            case 'value':
                return value;
            case 'minimum':
            case 'maximum':
            case 'exclusiveMinimum':
            case 'exclusiveMaximum':
                var svalue = $schema[matchrule];
                if (svalue !== undefined) {
                    if (typeof svalue === 'number') {
                        if (internal.schema.type === 'money') {
                            return fmoney_1.default(svalue);
                        }
                        else {
                            return fnumber_1.default(svalue);
                        }
                    }
                    if (internal.schema.type === 'string' && internal.schema.format === 'date') {
                        if (svalue.length >= 10) {
                            return svalue.substr(8, 2) + "." + svalue.substr(5, 2) + "." + svalue.substr(0, 4);
                        }
                        else {
                            return svalue;
                        }
                    }
                    return svalue;
                }
                return '';
            default:
                return $schema[matchrule] || '';
        }
    });
}
exports.getRuleMessage = getRuleMessage;
/**
 * pobranie komunikatu ostrzeżenia
 *
 * @export
 * @param {IInternal} internal dane wewnętrzne obiektu
 * @param {string} rule typ błedu
 * @param {*} value wartośc pola
 * @param {*} [$schema=null] schemat z wyliczonymi wartościami
 * @returns {string} komunikat ostrzeżenia
 */
function getWarningMessage(internal, rule, value, $schema) {
    if ($schema === void 0) { $schema = null; }
    $schema = $schema || internal.schema;
    var msg = internal.schema.warnings && internal.schema.warnings.warningMessages
        ? internal.schema.warnings.warningMessages[rule]
        : undefined;
    if (msg === undefined) {
        if (rule === 'format' && internal.schema.format) {
            msg = internal.options.validationMessages['format.' + internal.schema.format];
            if (msg === undefined) {
                msg = internal.options.validationMessages[internal.schema.format];
            }
        }
        else if (rule === 'type' && internal.schema.type) {
            msg = internal.options.validationMessages['type.' + internal.schema.type];
            if (msg === undefined) {
                msg = internal.options.validationMessages[internal.schema.type];
            }
        }
        if (msg === undefined) {
            msg = internal.options.warningMessages[rule] || rule;
        }
        // jeśli na starcie było zdefiniowane jako numer to od razu podmień
        if (typeof internal.schema.warnings[rule] === 'number') {
            msg = msg.replace(msgRegex[rule] || 'rrr', function () {
                return internal.schema.warnings[rule] === undefined
                    ? ''
                    : fnumber_1.default(internal.schema.warnings[rule]);
            });
        }
    }
    // zamiana {{maxLength}} na prawdziwą wartość
    return msg.replace(mustacheRegex, function (match, matchrule) {
        switch (matchrule) {
            case 'key':
                return internal.schema.$key || '';
            case 'title':
                return $schema.title || internal.schema.$key || '';
            case 'format':
                return internal.schema.format || '';
            case 'value':
                return value;
            case 'minimum':
            case 'maximum':
            case 'exclusiveMinimum':
            case 'exclusiveMaximum':
                var svalue = $schema.warnings[matchrule];
                if (svalue !== undefined) {
                    if (typeof svalue === 'number') {
                        if (internal.schema.type === 'money') {
                            return fmoney_1.default(svalue);
                        }
                        else {
                            return fnumber_1.default(svalue);
                        }
                    }
                    if (internal.schema.type === 'string' && internal.schema.format === 'date') {
                        if (svalue.length >= 10) {
                            return svalue.substr(8, 2) + "." + svalue.substr(5, 2) + "." + svalue.substr(0, 4);
                        }
                        else {
                            return svalue;
                        }
                    }
                    return svalue;
                }
                return '';
            default:
                return $schema.warnings[matchrule] || '';
        }
    });
}
exports.getWarningMessage = getWarningMessage;
exports.default = getRuleMessage;
//# sourceMappingURL=getRuleMessage.js.map